import React from 'react';
import { isWebComponentEnvironment } from '@/helpers';
import { INTERACTIVE_SVG_ID } from '@/constants';
import InteractiveSvg from '../shared/InteractiveSvg';
import PageRenderer from './PageRenderer';
import ShieldsDragSelection from './ShieldsDragSelection';
import FontsLoader from './FontsLoader';

const InteractiveRenderer = (props) => {
  const {
    className,
    visiblePagesUids,
    pagesSelection,
    pages,
    shieldsSelectionByDragRect,
    scaleCoef,
    width,
    height,
    viewboxX,
    viewboxY,
    zoomingContent,
    onContentDragEnd,
    onContentClick,
    onContentDblClick,
    onZooming,
    onZoomingEnd,
    onSwipe,
    isUserManipulatorTouch,
    fictiveSections,
    selWizard,
    setIsCableFlagSyncState,
    userSizeUnit,
    ...restPageProps
  } = props;

  const webComponent = isWebComponentEnvironment();
  const draggableContent = webComponent ? true : !shieldsSelectionByDragRect;
  const isShieldsDragSelectionAvailable = shieldsSelectionByDragRect;
  let horPageOffset = 0;

  return (
    <InteractiveSvg
      id={INTERACTIVE_SVG_ID}
      className={className}
      width={width}
      height={height}
      viewBox={`${viewboxX} ${viewboxY} ${width} ${height}`}
      zoomingContent={zoomingContent}
      draggableContent={draggableContent}
      onDragEnd={onContentDragEnd}
      onFastClickTap={onContentClick}
      onDblClickTap={onContentDblClick}
      onZooming={onZooming}
      onZoomingEnd={onZoomingEnd}
      onSwipe={onSwipe}
    >
      <FontsLoader />
      <rect x={viewboxX} y={viewboxY} width={width} height={height} fill="transparent" />
      {visiblePagesUids.map((pageUid, index) => {
        const isSelected = pagesSelection.indexOf(pageUid) >= 0;
        const page = pages[pageUid];
        if (index > 0) {
          const prevPage = pages[visiblePagesUids[index - 1]];
          if (prevPage) {
            const {
              box: { r, l },
            } = prevPage;
            horPageOffset += Math.abs(r - l);
          }
        }
        return (
          <PageRenderer
            key={page.uid}
            {...restPageProps}
            isSelected={isSelected}
            page={page}
            pages={pages}
            horPageOffset={horPageOffset}
            scaleCoef={scaleCoef}
            fictiveSections={fictiveSections}
            selWizard={selWizard}
            setIsCableFlagSyncState={setIsCableFlagSyncState}
            userSizeUnit={userSizeUnit}
          />
        );
      })}
      {isShieldsDragSelectionAvailable && (
        <ShieldsDragSelection
          svgRendererSelector={`#${INTERACTIVE_SVG_ID}`}
          isUserManipulatorTouch={isUserManipulatorTouch}
          visiblePagesUids={visiblePagesUids}
          pages={pages}
        />
      )}
    </InteractiveSvg>
  );
};

export default React.memo(InteractiveRenderer);